import type { Enum } from '@partou/core';

export const OBSERVATION_STATUSES = ['completed', 'pending', 'todo', 'expired', 'deleted'] as const;

export type ObservationStatus = Enum<typeof OBSERVATION_STATUSES>;
